import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval, Observable, PartialObserver, Subject, Subscription } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { ServiceSelectionDto } from 'src/app/services/dtos';
import { HttpOtpService } from 'src/app/services/http-otp.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
	selector: 'app-otp',
	templateUrl: './otp.component.html',
	styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit, OnDestroy {

	@Input() serviceSelection: ServiceSelectionDto;
	otp: string;
	sectionId: number;
	data: string;
	axonId: number;
	userRef: string;

	resendingOtp: boolean = false;
	timerSubscription: Subscription;
	ispause = new Subject();
	time = 30;
	timer: Observable<number>;
	timerObserver: PartialObserver<number>;

	private langChangeSub: Subscription;
	resendOtpText: string;
	resendOtpTextSecs: string;

	@Output() onNext = new EventEmitter();
	@Output() onBack = new EventEmitter();

	constructor(
		private toast: ToastService, 
		private spinner: NgxSpinnerService, 
		private otpService: HttpOtpService,
		private translate: TranslateService) {

	}

	ngOnInit(): void {
		this.sendOtp();

		this.setTranslatedText();
		
		this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.setTranslatedText();
		});
	}

	previousStep() {
		this.onBack.emit();
	}

	sendOtp() {
		this.otp = null;
		// this.otpService.generateOtp(this.serviceSelection.idNumber, this.serviceSelection.email, this.serviceSelection.recordAction, this.serviceSelection.profileType)
		this.otpService.generateOtp(this.serviceSelection)
			.pipe(
				catchError(error => {
					this.spinner.hide();
					console.log('Error', error);

					this.toast.show('Failed to connect to server');
					throw error;
				})
			)
			.subscribe(
				data => {
					this.spinner.hide();
					console.log('data', data);
					if (!data) {
						console.log('Error', data);
						this.toast.show('Error requesting OTP');
					} else {

						if (data.isError) {
							this.toast.show(data.error);
							this.previousStep();
							return;
						}

						this.sectionId = data.sectionId;
						this.axonId = data.axonId;
						this.data = data.data;
						this.userRef = data.userRef;

						if (this.resendingOtp) {
							this.startOtpLimitCounter();
						}
					}
				}
			);
	}

	resendOtp() {
		if (!this.resendingOtp) {
			this.resendingOtp = true;
			this.sendOtp();
		}
	}

	private startOtpLimitCounter() {
		this.timer = interval(1000)
			.pipe(
				takeUntil(this.ispause)
			);

		this.timerObserver = {
			next: (_: number) => {
				if (this.time == 0) { 
					this.ispause.next; 
					this.time = 30;
					this.resendingOtp = false;
				} else {
					this.time -= 1;
				}
			}
		};

		this.timerSubscription = this.timer.subscribe(this.timerObserver);
	}

	ngOnDestroy(): void {
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
		this.langChangeSub?.unsubscribe();
	}

	nextStep() {
		//Verify OTP with server
		if (!this.otp || this.otp === null) {
			this.toast.show('Please enter the OTP that was emailed / SMSed to you');
			return;
		}
		console.log("Emiting jsonData:", this.data);
		this.onNext.emit({ 'sectionId': this.sectionId, 'otp': this.otp, 'axonId': this.axonId, 'userRef': this.userRef, 'jsonData': this.data });
	}

	get resendOtpButtonText(): string {
		if (this.resendingOtp) {
			return this.resendOtpText + ' (' + this.time + ' ' + this.resendOtpTextSecs + ')'
		}
		return this.resendOtpText;
	}

	private setTranslatedText() {
		this.translate.get('RESEND_OTP').subscribe(value => {
			this.resendOtpText = value;
		});
		this.translate.get('SECS').subscribe(value => {
			this.resendOtpTextSecs = value;
		});
	}

}
